import { orderBy } from 'lodash-es'

import type { SelectFieldProps } from '@fv/client-components'
import { type LoadDocumentType, loadDocumentTypeConfigs } from '@fv/models'

import { SelectField } from './inputs/SelectField'

export type SelectableDocumentType = LoadDocumentType | 'carrier-bol' | ''

const shipperOptions = orderBy(
  [...loadDocumentTypeConfigs],
  [i => i.key === 'other', i => i.name],
  ['asc', 'asc'],
)
  .filter(c => c.allowedSources.includes('shipper'))
  .map(({ key, name }) => ({
    text: name,
    value: key,
  }))
const docTypeOptions: Array<{
  text: string
  value: SelectableDocumentType
}> = [{ text: 'Choose document type...', value: '' }, ...shipperOptions]

type Props = Omit<SelectFieldProps, 'value' | 'options'> & {
  value: SelectableDocumentType
}
export const DocTypeSelector = (props: Props) => {
  return <SelectField {...props} options={docTypeOptions} value={props.value} />
}
